import { Routes, Route } from 'react-router-dom'
import KioskPage from './features/kiosk/KioskPage'
import AdminPage from './features/admin/AdminPage'
import { Toaster } from './components/ui/toaster'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/" element={<KioskPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster />
    </div>
  )
}

export default App 